import T from '@wojtekmaj/react-t';

import { Image, ImageContainer, Text, Wrapper } from './slide.styles';

type SlideProps = {
  fetchPriority?: 'auto' | 'high' | 'low';
  image: string;
  text: string;
};

export default function Slide({ fetchPriority, image, text }: SlideProps) {
  return (
    <Wrapper>
      <ImageContainer>
        <Image alt="" fetchPriority={fetchPriority} height={404} src={image} width={375} />
      </ImageContainer>
      <Text>
        <T>{text}</T>
      </Text>
    </Wrapper>
  );
}
